import Model from '@/app/Model'

export class ModelCategory extends Model {
	static fields () {
		return {
			id: null,
			name: null,
			startDate: null,
			endDate: null
		}
	}
	static hasMany () {
		return {
			//
		}
	}
}

export function CreateModel (data) {
	return Object.freeze(new ModelCategory(data))
}
